interface PublishStatusMap {
  [status: string]: string
}

export function formatPublishSiteStatus(status: boolean): string {
  return status ? '公開中' : '非公開'
}
